import { getDataFromServer } from '../../../util';

export class ModelExplainAbilityModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchModelExplainAbility = async (payload) => {
    const { customerKey, category, limit, offset, alertId } = payload;

    const params = {
      explainabilityCategory: category,
      limit,
      offset,
      alertId
    };

    const data = await getDataFromServer(
      `${this.baseURL}/customers/${customerKey}/modelExplainability`,
      this.httpHeaders,
      params
    );

    return { data };
  };

  fetchModelExplainAbilityStats = async (payload) => {
    const { customerKey, alertId } = payload;

    const stats = await getDataFromServer(
      `${this.baseURL}/customers/${customerKey}/explainabilityStats`,
      this.httpHeaders,
      { alertId }
    );

    return { stats };
  };
}
